import { LayoutHOC } from 'base/ui/layout/layout';
import { createProductionPlanning } from '.';

export const createProductionPlanningReportPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createProductionPlanning());
};
